import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { useLocalizedNavigate } from 'src/hooks/use-localized-navigate'
import HrSidebar from './hr-sidebar.component'

export const HRLayout = () => {
  const { project, isFeatureActivated } = useCurrentProject()
  const navigate = useLocalizedNavigate()

  useEffect(() => {
    if (!isFeatureActivated('is-hr-activated')) {
      navigate(`/${project.id}/medical`, { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.id])

  if (!isFeatureActivated('is-hr-activated')) return null

  return (
    <>
      <HrSidebar />
      <main className="c-px-4 c-py-4 c-w-full [&>*]:c-w-full c-relative c-flex-grow c-flex c-overflow-y-scroll c-overflow-x-hidden">
        <Outlet />
      </main>
    </>
  )
}
